import { c as _c } from "react/compiler-runtime";
import { Button, Centre, Heading, Text, VStack } from '@jaaq/hub-ui';
import { cn } from '@jaaq/hub-ui/cn';
import { CirclePlay } from 'lucide-react';
import type { ReactElement, ReactNode } from 'react';
type RecommendationCardProps = {
  title: string;
  tagline: string;
  bullets: string[];
  icon: ReactNode;
  isRecommended: boolean;
  onChoose: () => void;
  onExplore: () => void;
};
export const RecommendationCard = t0 => {
  const $ = _c(39);
  const {
    title,
    tagline,
    bullets,
    icon,
    isRecommended,
    onChoose,
    onExplore
  } = t0;
  let t1;
  if ($[0] !== isRecommended) {
    t1 = isRecommended && <div className="absolute -top-3 left-5 bg-jaaq-accent px-3 py-1 rounded-sm z-10"><Text as="span" variant="small" tone="inverse" className="font-bold uppercase">Recommended</Text></div>;
    $[0] = isRecommended;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = isRecommended ? "ring-2 ring-jaaq-accent" : "";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("bg-surface rounded-lg p-5 h-full transition-all", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== icon) {
    t4 = <Centre className="size-12 rounded-lg bg-black/5 shrink-0">{icon}</Centre>;
    $[4] = icon;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== title) {
    t5 = <Heading level={2} variant="subtitle" className="uppercase">{title}</Heading>;
    $[6] = title;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== tagline) {
    t6 = <Text className="mb-3.5">{tagline}</Text>;
    $[8] = tagline;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== bullets) {
    t7 = bullets.map(_temp);
    $[10] = bullets;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <ul className="list-disc space-y-0">{t7}</ul>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t8) {
    t9 = <div className="text-sm leading-5 text-fg">{t6}{t8}</div>;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="h-px bg-border" />;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <CirclePlay className="size-4 shrink-0" strokeWidth={1.5} />;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== onExplore || $[20] !== title) {
    t12 = <Button variant="ghost" size="regular" onClick={onExplore} className="w-full">{t11}Explore {title}</Button>;
    $[19] = onExplore;
    $[20] = title;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== onChoose || $[23] !== title) {
    t13 = <Button variant="dark" size="regular" onClick={onChoose} className="w-full">Choose {title}</Button>;
    $[22] = onChoose;
    $[23] = title;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t12 || $[26] !== t13) {
    t14 = <VStack gap={2} className="mt-2">{t10}{t12}{t13}</VStack>;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t14 || $[29] !== t5 || $[30] !== t9) {
    t15 = <VStack gap={2} className="flex-1">{t5}{t9}{t14}</VStack>;
    $[28] = t14;
    $[29] = t5;
    $[30] = t9;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t15 || $[33] !== t3 || $[34] !== t4) {
    t16 = <VStack gap={4} className={t3}>{t4}{t15}</VStack>;
    $[32] = t15;
    $[33] = t3;
    $[34] = t4;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t1 || $[37] !== t16) {
    t17 = <div className="relative flex-1 min-w-0">{t1}{t16}</div>;
    $[36] = t1;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  return t17;
};
function _temp(bullet) {
  return <li key={bullet} className="ms-[21px]">{bullet}</li>;
}